"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggerEventEmitter = void 0;
var _EventEmitter = require("./EventEmitter");
/**
 * Custom event emitter for Logger
 */
const loggerEventEmitter = exports.loggerEventEmitter = new _EventEmitter.EventEmitter();
//# sourceMappingURL=loggerEventEmitter.js.map